const adFloor = document.querySelector('.floor-ad');
if (adFloor) {
  // Adds default class (no floorAd)
  document.body.classList.add('body-no-floor-ad');

  // Select the node that will be observed for mutations
  const targetNode = document.querySelector(
    '.floor-ad__wrapper > .block-pa-ad'
  );

  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        const targetImg = mutation.target.querySelector('a > img');
        if (targetImg && targetImg.getAttribute('height') !== '0') {
          document.body.classList.remove('body-no-floor-ad');
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  if (targetNode) {
    observer.observe(targetNode, config);
  }

  // Adds eventListener on floorAd button
  const adFloorBtn = adFloor.querySelector('.floor-ad__btn');
  adFloorBtn.addEventListener('click', function () {
    adFloor.classList.add('hide');
    document.body.classList.add('body-no-floor-ad');
  });
}
